// app.feedback.tsx — the send-feedback form.
export const feedback = {
  pageHeading: "Send feedback",
  intro: {
    heading: "Tell us what's working and what's not",
    body:
      "We read every reply. The fastest way to influence what we ship next is to file a clear note here — we triage and respond to every report within 2 business days.",
    shopLabel: "Shop:",
    tierLabel: "Tier:",
  },
  success: {
    banner: "Thanks — we got it. We'll get back to you within 2 business days.",
    trackedPublicly: "Tracked publicly:",
  },
  form: {
    heading: "Your feedback",
    subjectLabel: "Subject",
    subjectPlaceholder: "e.g. PO upload silently fails for 2-page POs",
    roleLabel: "What's your relationship to this shop?",
    roleOptions: {
      merchant: "I run this shop",
      reviewer: "App Store reviewer",
      buyer: "B2B buyer using this shop",
      other: "Other",
    },
    contactEmailLabel: "Reply-to email (optional)",
    contactEmailPlaceholder: "we@email-you.com — leave blank to stay anonymous",
    bodyLabel: "Tell us what happened",
    bodyPlaceholder:
      "Steps to reproduce + what you expected + what happened. Screenshots welcome — paste links.",
    sendButton: "Send feedback",
  },
  errors: {
    subjectRequired: "Subject is required (≤200 chars).",
    messageRequired: "Message is required (≤8000 chars).",
  },
};
